export default __webpack_public_path__ + "static/report-content-05-8897fc1be44a31cad7402b83538df319.png";